import { TNewbuildingBrokerConfig } from '../../../types/newbuildingBroker';
import { useApplicationContext } from '../../../utils/applicationContext';

export const useNewbuildingBrokerEnabled = (): TNewbuildingBrokerConfig => {
  const { config } = useApplicationContext();

  const brokerConfig: TNewbuildingBrokerConfig | null = config.get('newbuildingBroker');

  return {
    enabled: brokerConfig?.enabled || false,
  };
};
